import React from 'react';
import { Search as SearchIcon } from '@material-ui/icons';
import { InputAdornment, TextField } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

const SearchByText = ({ setTextValueAction, changeStyles, textValueAction }) => {
  const { t } = useTranslation();

  const removeAccents = (str) => str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

  const getTextValue = (keyword) => keyword ? removeAccents(keyword).toLowerCase() : null;

  const onKeywordChange = (event) => {
    const keywordVal = getTextValue(event.target.value);
    setTextValueAction(keywordVal);
  };

  return (
    <TextField
      variant='outlined'
      fullWidth
      InputLabelProps={{
        shrink: true
      }}
      InputProps={{
        'aria-label': 'search',
        startAdornment: (
          <InputAdornment position='start'>
            <SearchIcon />
          </InputAdornment>
        )
      }}
      value={textValueAction}
      onChange={onKeywordChange}
      label={!changeStyles ? t('searchToolbar:search') : t('bundleListView:searchByDocumentText')}
      placeholder={!changeStyles ? t('searchToolbar:search') : t('bundleListView:searchByDocumentText')}
      autoFocus
    />
  );
};

export default SearchByText;
